import SyntheseModeleDetailController from './synthesemodele.detail.controller';

export default {
    template: require('./synthesemodele.detail.html'), //'app/common/synthesemodeles/components/synthesemodele-detail/synthesemodele.detail.html',
    controller: SyntheseModeleDetailController
};
